import { EnergyTypeDto } from '@eneco/dc-be/client';
import { Electricity, ElectricityGasHeating, Gas } from '@eneco/sparky/illustrations';

export const EnergyIllustration = ({
  energyType,
  size = 'medium',
}: {
  energyType: EnergyTypeDto;
  size?: 'small' | 'medium' | 'large';
}) => {
  if (energyType === 'Both') return <ElectricityGasHeating size={size} />;
  if (energyType === 'Electricity') return <Electricity size={size} />;
  return <Gas size={size} />;
};
